import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const script = document.createElement('script');
script.src = `https://tags.tiqcdn.com/utag/${environment.TEALIUM.CUENTA}/${environment.TEALIUM.PERFIL}/${environment.TEALIUM.ENTORNO}/utag.sync.js`;
script.async = true;
document.head.appendChild(script);

if (environment.PRODUCTION) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
